import script from "./GestionTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionTickets.vue?vue&type=script&setup=true&lang=js"

import "./GestionTickets.vue?vue&type=style&index=0&id=2a7ab117&scoped=true&lang=css"
import "./GestionTickets.vue?vue&type=style&index=1&id=2a7ab117&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7ab117"]])

export default __exports__